import { render, staticRenderFns } from "./Dashboard-lambo.vue?vue&type=template&id=161c0ad6&scoped=true&"
import script from "./Dashboard-lambo.vue?vue&type=script&lang=js&"
export * from "./Dashboard-lambo.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-lambo.vue?vue&type=style&index=0&id=161c0ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c0ad6",
  null
  
)

export default component.exports